import React, { Component } from "react";

import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import ColumnBody from "./ColumnBody";
import ColumnHeader from "./ColumnHeader";
import ColumnItem from "./ColumnItem";
import NewColumn from "./NewColumn";
import NewColumnItem from "./NewColumnItem";
// import SmallNavbar from '/icons/menu.png'
// import logo from '../../icons/menu.png';
import { getBoundingClientRect } from '../../../utils/functions';

class Column extends Component {
    constructor(props) {
        super(props);
        this.setPositionDiv = React.createRef();
    }

    componentDidMount() {
        // console.log('llllll====', this.props.headerInfo)
    }

    render() {
        const {
            columnid,
            columnHeader,
            addNewColumn,
            removeNewColumn,
            removeNewSubColumn,
            columnList,
            addTofavorite,
            like,
            onRenameItem,
            newTask,
            setNewTask,
            columnItemsLength,
            addNewItem,
            index,
            headerInfo,
            fullData,
        } = this.props;

        return (
            <div className="h-100 " >
                <div style={{ position: "fixed", top: "0", left: "0" }} ref={this.setPositionDiv}></div>
                <Draggable draggableId={`${columnid}`} index={index} >
                    {(provided, snapshot) => {
                        // console.log('provided', provided, snapshot)

                        // provided.draggableProps.style.overflow = 'auto';

                        if (snapshot.isDragging) {
                            if (!provided.draggableProps) {
                                provided.draggableProps = { style: {} }
                            }
                            let bound = getBoundingClientRect(this.setPositionDiv.current)
                            const offset = { x: bound.left, y: bound.top }
                            const x = (provided.draggableProps?.style?.left ?? 0) - offset.x;
                            const y = (provided.draggableProps?.style?.top ?? 0) - offset.y;
                            // console.log("y:", y, "x:", x)
                            provided.draggableProps.style.left = x;
                            provided.draggableProps.style.top = y;
                            provided.draggableProps.style.backgroundColor = '#f8f8f8dd';
                            provided.draggableProps.style.boxShadow = '0px 0px 50px #10101020';


                        }
                        return (
                            <div className="task-card mld-2  br-10 is-active h-100 overflow-auto" style={{ ...provided.draggableProps.style }} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                {/* {console.log('porppods', columnHeader)} */}
                                <div className="task-header pb-2 pt-2 px-2" style={{ position: "sticky", top: 0, zIndex: 1, backgroundColor: '#f8f8f8' }}>
                                    <ColumnHeader setNewTask={setNewTask} fullData={fullData} headerInfo={headerInfo} view={this.props.view} column={this.props.column} onRenameItem={onRenameItem} columnid={columnid} addTofavorite={addTofavorite} like={like} addNewColumn={addNewColumn} removeNewColumn={removeNewColumn} columnHeader={columnHeader} columnItemsLength={columnItemsLength} dragpHand={provided.dragHandleProps} functionsHandler={this.props.functionsHandler} />
                                </div>
                                <div className="kanban-column position-relative pb-5 px-2">
                                    <ColumnBody setNewTask={setNewTask} actions={this.props.actions} page={this.props.page}  view={this.props.view} column={this.props.column} removeNewSubColumn={removeNewSubColumn} width={this.props.width} headers={this.props.headers} columnList={columnList} columnid={columnid} addNewItem={addNewItem} functionsHandler={this.props.functionsHandler} />
                                </div>
                            </div>
                        )
                    }}
                </Draggable>
            </div>
        );
    }
}

export default Column;

// const onDragEnd = (result) => { };


// const Column = ({
//     columnid,
//     columnHeader,
//     addNewColumn,
//     removeNewColumn,
//     columnList,
//     addTofavorite,
//     like,
//     onRenameItem,
//     newTask,
//     setNewTask,
//     columnItemsLength,
//     addNewItem,
//     index,
// }) => {
//     const setPositionDiv = useRef();
//     return (
//         <div className="">
//             <div style={{ position: "fixed", top: "0", left: "0" }} ref={setPositionDiv}></div>
//             <Draggable draggableId={`${columnid}`} index={index}>
//                 {(provided, snapshot) => {
//                     console.log('provided', provided, snapshot)
//                     if (snapshot.isDragging) {
//                         if (!provided.draggableProps) {
//                             provided.draggableProps = { style: {} }
//                         }
//                         let bound = getBoundingClientRect(setPositionDiv.current)
//                         const offset = { x: bound.left, y: bound.top }
//                         const x = (provided.draggableProps?.style?.left ?? 0) - offset.x;
//                         const y = (provided.draggableProps?.style?.top ?? 0) - offset.y;
//                         console.log("y:", y, "x:", x)
//                         provided.draggableProps.style.left = x;
//                         provided.draggableProps.style.top = y;

//                     }
//                     return (
//                         <div className="task-card mld-2 p-2 br-10" style={{ ...provided.draggableProps.style }} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
//                             <ColumnHeader onRenameItem={onRenameItem} columnid={columnid} addTofavorite={addTofavorite} like={like} setNewTask={setNewTask}  addNewColumn={addNewColumn} removeNewColumn={removeNewColumn} columnHeader={columnHeader} columnItemsLength={columnItemsLength} dragpHand={provided.dragHandleProps} />
//                             <div className="kanban-column mt-2">
//                                 <ColumnBody setNewTask={setNewTask} newTask={newTask} columnList={columnList} columnid={columnid} addNewItem={addNewItem} />
//                             </div>
//                         </div>
//                     )
//                 }}
//             </Draggable >
//         </div >
//     );
// };

// export default Column;
// import React, { Component, useRef } from "react";


// <Droppable droppableId={columnid}>
//     {(provided) => (
//         <ColumnBody
//             columnList={columnList}
//             ref={provided.innerRef}
//             {...provided.droppableProps}
//             index={columnid}
//         >
//             {provided.placeholder}
//         </ColumnBody>
//     )}
// </Droppable>;
